module.exports = __webpack_public_path__ + "img/alior.4e9f88dc.png";